<template>
  <fragment>
    <b-modal
      :body-class="{ static: hoverTool, 'scrollbar-is-show': scrollbarIsShow }"
      id="modal-manage-header-menu"
      scrollable
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      @shown="modalShown"
      @show="initData"
    >
      <template #modal-header>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="modal-title fs-db-28">
              {{$t('engine.manageHeader.widgetMenu.manageMenu.lblTitle', languageEngine)}} -
              {{ languageUse && languageUse.toUpperCase() }}
              <i
                :class="`flag-icon flag-icon-${
                  languages &&
                  languages[languageUse] &&
                  languages[languageUse].flagIcon
                }`"
              ></i>
            </h5>
            <div class="d-flex align-items-center">
              <div class="icon-question">
                <i class="fal fa-question-circle"></i>
              </div>
              <div
                @click="closeModal(), (text = ''), (expand_id = '')"
                type="button"
                aria-label="Close"
                id="close-modal-manage-header-menu"
                class="ml-10 icon-close-modal"
              >
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center pt-gd-2">
            <b-button variant="blue" class="btn-add-menu" @click="addMenu">
              <i class="fas fa-plus"></i>{{ " " }}{{$t('engine.manageHeader.widgetMenu.manageMenu.lblBtnAddMenu', languageEngine)}}</b-button
            >
            <div class="wrapper-search">
              <span class="icon-search">
                <i class="far fa-search"></i>
              </span>
              <b-form-input
                v-model="text"
                :placeholder="$t('engine.manageHeader.widgetMenu.manageMenu.lblPlaceholderSearchMenu', languageEngine)"
              />
              <span
                v-show="text !== ''"
                class="icon-clear-text"
                @click="text = ''"
              >
                <i class="fas fa-times-circle"></i>
              </span>
            </div>
          </div>
        </div>
      </template>

      <div id="wrapper-body">
        <div id="wrapper-body-inner">
          <div v-if="text !== ''" class="">
            {{$t('engine.manageHeader.widgetMenu.manageMenu.lblSearchResult', languageEngine)}} ({{ countSearch }})
            <hr class="mt-0 mb-15" />
          </div>
          <div
            class="text-center text-muted"
            v-if="countSearch === 0 && text !== ''"
          >
            {{$t('engine.manageHeader.widgetMenu.manageMenu.lblNoSearchResult', languageEngine)}}
          </div>
          <NestedWrapper v-if="menuNested.length > 0">
            <VueNestable
              v-model="menuNested"
              :class="{'pos-unset': expand_id}"
              :max-depth="4"
              children-prop="componentsID"
              @change="setData"
            >
              <template slot-scope="{ item, isChild }">
                <VueNestableHandle
                  :item="item"
                  v-if="item.show != false"
                  class="handler"
                  :draggable="!disableDrag"
                >
                  <PanelItem class="d-flex justify-content-between" :text="text" :id="`menu-item-${item.id}`"
                    v-if="(item.properties.isEnable != null) || (item.properties.isEnable != undefined)"
                    :class="{
                      active: expand_id === `tools${item.id}`,
                      bactive: expand_id,
                      disabled: !item.properties.isEnable
                    }"
                  >
                    <div class="fs-sa-14">
                      <span
                        class="cursor-move"
                        :class="{ home: !isChild && getMainPage.id === item.id }"
                      >
                        <Home class="home-icon"></Home>
                        <DragIcon class="drag-icon bi-three-dots-vertical drag-icon b-icon bi text-dark handle"></DragIcon>

                      </span>
                      {{ item.properties.name }}
                    </div>
                    <span class="d-inline-flex text-muted">
                      <span
                        class="mr-2"
                        v-b-tooltip.hover
                        :title = "$t('engine.manageHeader.widgetMenu.manageMenu.lblToolHideMenu', languageEngine)"
                        v-if="item.properties.isEnable === false"
                      >
                        <EyeSlash></EyeSlash>
                      </span>
                      <div class="tool cursor-pointer">
                        <div
                          class="cursor-pointer tools-more-menu"
                          :id="`tools${item.id}`"
                          @click.stop="fixExpand(item)"
                          @touchstart.stop="disableDrag = true"
                          @touchend.stop="fixExpand(item)"
                          :class="{active: expand_id === `tools${item.id}`}"
                        >
                          <Ellipsis 
                            class="text-muted mb-3 icon-more-menu"
                            style="pointer-events: none; font-size: 14px"
                          ></Ellipsis>
                        </div>

                        <b-popover
                          :target="`tools${item.id}`"
                          triggers="click"
                          placement="rightbottom"
                          ref="popover"
                          :container="`tools${item.id}`"
                          content
                          boundary="viewport"
                        >
                          <div>
                            <div
                              class="cursor-pointer option fs-sa-14"
                              @click="editMenu(item.id, isChild, item.properties.isEnable)"
                            >
                              <span>
                                <i class="far fa-edit mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{$t('engine.manageHeader.widgetMenu.manageMenu.lblToolEditMenu', languageEngine)}}
                            </div>

                            <div
                              class="cursor-pointer option fs-sa-14"
                              @click="confirmHide(item.id)"
                            >
                              <span v-show="item.properties.isEnable">
                                <i class="far fa-eye mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              <span v-show="!item.properties.isEnable">
                                <i class="far fa-eye-slash mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{ !item.properties.isEnable ? $t('engine.manageHeader.widgetMenu.manageMenu.lblToolShowMenu', languageEngine) : $t('engine.manageHeader.widgetMenu.manageMenu.lblToolHideMenu', languageEngine) }}
                            </div>

                            <div
                              class="cursor-pointer option fs-sa-14"
                              :disabled="item.componentsID.length > 0"
                              @click="item.componentsID.length === 0 ? confirmDelete(item.id) : $bvModal.show(`modal-cannot-delete-header-menu`)" 
                            >
                              <span>
                                <i class="far fa-trash-alt mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{$t('engine.manageHeader.widgetMenu.manageMenu.lblToolDeleteMenu', languageEngine)}}
                            </div>
                          </div>
                        </b-popover>
                      </div>
                    </span>
                  </PanelItem>
                </VueNestableHandle>
              </template>
            </VueNestable>
          </NestedWrapper>
          <WrapperEmpty v-else class="help-empty text-center">
            {{$t('engine.manageHeader.widgetMenu.manageMenu.lblHelpEmpty', languageEngine)}}
          </WrapperEmpty>
        </div>
      </div>
    </b-modal>
    <AddMenu
      :action="action"
      :id="item_id"
      :isChild="isChild"
      @clear="(action = ''), (item_id = ''), (text = ''), (isChild = false)"
      @scrollToMenu="scrollToMenu"
    />
    <DialogConfirmHideMenu
      :item_name="item_name"
      @confirmed="setChidrenStatus(item_id)"
      @clear="(action = ''), (item_id = ''), (text = ''), (isChild = false)"
    />
    <ConfirmDelete
      :item_name="item_name"
      @confirmed="deleteItem(item_id)"
      :isChild="isChild"
      :isEnable="isEnable"
      @clear="
        (action = ''),
          (item_id = ''),
          (text = ''),
          (isChild = false),
          (isEnable = true)
      "
    />
    <DialogWaringDelete />
  </fragment>
</template>

<script>
import { VueNestable, VueNestableHandle } from "vue-nestable";
import { mapGetters } from "vuex";
import AddMenu from "@components_system/Design/Modal/Header/AddMenu/AddMenu";
import Home from "@components_system/Shared/Images/Icon/Home";
import DragIcon from "@components_system/Shared/Images/Icon/DragIcon";
import EyeSlash from "@components_system/Shared/Images/Icon/EyeSlash";
import Ellipsis from "@components_system/Shared/Images/Icon/Ellipsis";
import { PanelItem, NestedWrapper, WrapperEmpty } from "./ManageMenu.styled";
import ConfirmDelete from "./dialogConfirmDelete.vue";
import DialogWaringDelete from "./dialogWaringDelete.vue";
import DialogConfirmHideMenu from "./dialogConfirmHideMenu.vue";

export default {
  data() {
    return {
      text: "",
      item_id: "",
      expand_id: "",
      item_name: "",
      action: "",
      isChild: false,
      countSearch: 0,
      hoverTool: false,
      isEnable: true,
      scrollbarIsShow: undefined,
      menuNested: [],
      isSave : false,
      disableDrag: false,
    };
  },
  components: {
    PanelItem,
    VueNestable,
    VueNestableHandle,
    NestedWrapper,
    WrapperEmpty,
    AddMenu,
    ConfirmDelete,
    DialogWaringDelete,
    DialogConfirmHideMenu,
    Home,
    DragIcon,
    EyeSlash,
    Ellipsis,
  },
  computed: {
    ...mapGetters({
      languages: "design/site/languages",
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
      siteComponents: "design/metadata/siteComponents",
      modal: "design/modal",
    }),
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      let mapMainPage = Object.entries(JSON.parse(JSON.stringify(this.siteComponents)))
        .filter((cpn) => cpn[1].type === "HEADER_MENU")
        .filter(
          (headerMenu) =>
            headerMenu[1].properties.link.type == "page" &&
            headerMenu[1].properties.link.pageID === mainPageID
        )[0];
      return (mapMainPage && mapMainPage[1]) || [];
    },
    stringHeader(){
      return JSON.stringify(this.siteComponents.HEADER_WIDGET_MENU);
    },
    stringMenuNested() {
      return JSON.stringify(this.menuNested);
    },
  },
  mounted() {
    this.$root.$on("bv::modal::shown", () => {
      const _vm = this;
      $(".modal").on("click", function (bvEvent) {
        if (
          _vm.expand_id &&
          bvEvent.target.className != "cursor-pointer tools-more-menu active"
        ) {
          _vm.$root.$emit("bv::hide::popover", _vm.expand_id);
          _vm.expand_id = "";
          _vm.enable();
        }
      });
    });
  },
  watch: {
    text() {
      this.countSearch = 0;
      this.initData();
    },
    modal: {
      handler() {
        if (this.modal == "modal-manage-header-menu") {
          this.$bvModal.show("modal-manage-header-menu");
        }
      },
    },
  },
  methods: {
    modalShown() {
      this.getScrollbarIsShow()
    },
    getScrollbarIsShow() {
      let a = 0;
      let myInterval = setInterval(() =>{
        let modalBody = document.getElementsByClassName('modal-body')
        let wrapperBody = document.getElementById('wrapper-body')
        if (modalBody.length > 0 && wrapperBody) {
          this.resizeObserver = new ResizeObserver(() => {
            if (modalBody.length > 0 && wrapperBody) {   
              if (wrapperBody.getBoundingClientRect().height > modalBody[0].getBoundingClientRect().height) {
                this.scrollbarIsShow = true;
              } else {
                this.scrollbarIsShow = false;
              }
            }
          }).observe(
            wrapperBody
          );
          clearInterval(myInterval);
        }
        if(a >= 1000) {
          clearInterval(myInterval);
        }
        a = a + 1;
      }, 150);
    },
    closeModal() {
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide("modal-manage-header-menu");
    },
    preventScroll(e) {
      e.preventDefault();
    },
    disable() {
      document
        .querySelector(".modal-body")
        .addEventListener("wheel", this.preventScroll);
      this.disableDrag = true
    },
    enable() {
      document
        .querySelector(".modal-body")
        .removeEventListener("wheel", this.preventScroll, false);
      this.disableDrag = false
    },
    fixExpand(item) {
      if (`tools${item.id}` === this.expand_id) {
        this.expand_id = "";
        this.enable();
      } else {
        this.expand_id = String(`tools${item.id}`);
        this.disable();
      }
    },
    addMenu() {
      this.action = "add";
      console.log("addMenu", this.action);
      this.$bvModal.hide("modal-manage-header-menu");
      this.$bvModal.show("modal-addedit-header-menu");
    },
    editMenu(id, isChild, status) {
      this.item_id = id;
      this.action = "edit";
      this.isChild = isChild;
      this.isEnable = status;
      this.$bvModal.hide("modal-manage-header-menu");
      this.$bvModal.show("modal-addedit-header-menu");
    },
    confirmHide(item_id) {
      if (this.siteComponents[item_id].properties.isEnable) {
        this.item_id = item_id;
        this.item_name = this.siteComponents[item_id].properties.name;
        this.$bvModal.show("modal-confirm-hide-header-menu");
      } else {
        this.setChidrenStatus(item_id);
      }
      this.initData();
    },
    confirmDelete(id) {
      this.item_id = id;
      this.item_name = this.siteComponents[id].properties.name;
      this.$bvModal.show("modal-confirm-delete-menu");
    },
    deleteItem(id) {
      this.deStructure(this.menuNested,'root')
      this.text = "";
      const index =
        this.siteComponents.HEADER_WIDGET_MENU.componentsID.findIndex(
          (item) => item === id
        );
      if (index !== -1) {
        this.siteComponents.HEADER_WIDGET_MENU.componentsID.splice(index, 1);
        delete this.siteComponents[id];
      } else {
        Object.keys(this.siteComponents).map((item) => {
          if (
            this.siteComponents[item] &&
            this.siteComponents[item].type === "HEADER_MENU"
          ) {
            const index = this.siteComponents[item].componentsID.findIndex(
              (item) => item === id
            );
            if (index !== -1) {
              this.siteComponents[item].componentsID.splice(index, 1);
              delete this.siteComponents[id];
            }
          }
        });
      }
      this.snap();
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t('engine.manageHeader.widhrTopMenu.AddEditMenu.msgDeletemenuSuccess', this.languageEngine)});
      this.initData();
    },
    setChidrenStatus(item_id, parent_id = "") {
      this.deStructure(this.menuNested,'root');
      this.text = "";
      var key = item_id;
      var status = !this.siteComponents[item_id].properties.isEnable;
      if (parent_id !== "") {
        status = this.siteComponents[parent_id].properties.isEnable;
      }
      this.siteComponents[key].properties.isEnable = status;
      if (this.siteComponents[key].componentsID.length > 0) {
        this.siteComponents[key].componentsID.map((id) => {
          this.setChidrenStatus(id, key);
        });
      }
      this.snap();
      if (parent_id == "") {
        this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), 
          message: this.$t(`engine.manageHeader.widhrTopMenu.AddEditMenu.msg${status ? 'Show' : 'Hide'}menuSuccess`, this.languageEngine)
        });
      }
      this.initData();
      return;
    },
    snap() {
      this.$store.dispatch("design/snapshot/genSnapshot");
    },
    initData() {
      const data = this.siteComponents.HEADER_WIDGET_MENU  ? this.createNested() : [];
      this.text != "" ? this.filterText(data) : this.cleanFilterText(data);
      this.menuNested = data;
      this.isSave = false;
    },
    createNested(items = this.siteComponents.HEADER_WIDGET_MENU.componentsID) {
      var data = [];
      items.map((item) => {
        if (this.siteComponents[item] && this.siteComponents[item].id) {
          data.push({
            id : this.siteComponents[item].id, 
            componentsID : this.siteComponents[item].componentsID ,
            properties: this.siteComponents[item].properties
          });
          if (this.siteComponents[item].componentsID.length > 0) {
            const index = data.findIndex((menu) => menu.id === item);
            data[index].componentsID = this.createNested(this.siteComponents[item].componentsID);
          }
        }
      });
      return data;
    },
    cleanFilterText(arr) {
      this.countSearch = 0;
      return arr.map((item) => {
        if ( item.componentsID && Array.isArray(item.componentsID) && item.componentsID.length > 0 ) {
          this.cleanFilterText(item.componentsID);
        }
        item.show = true;
        return item;
      });
    },
    filterText(arr) {
      return arr.map((item) => {
        let findChild = false;
        if ( item.componentsID && Array.isArray(item.componentsID) && item.componentsID.length > 0 ) {
          this.filterText(item.componentsID);
          findChild = item.componentsID .map((i) => i.show).reduce((a, b) => a || b);
        }
        if (this.siteComponents[item.id].properties.name) {
          if ( this.siteComponents[item.id].properties.name.toLowerCase().search(this.text.toLowerCase()) > -1 ) {
            item.show = true;
            this.countSearch++;
          } else {
            item.show = findChild || false;
          }
        }
        return item;
      });
    },
    setData() {
      this.deStructure(this.menuNested,"root");
    },
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    deStructure(items, state) {
      var list_root = [];
      if (state == "root") {
        items.map((item) => {
          list_root.push(this.deepCopy(item.id));
        });
        this.siteComponents.HEADER_WIDGET_MENU.componentsID = list_root;
      }
      items.map((item,index) => {
        delete item.show;
        if (this.siteComponents[item.id] && this.siteComponents[item.id].id) {
          this.siteComponents[item.id] = { ...this.deepCopy(this.siteComponents[item.id]) , ...{componentsID : item.componentsID.map(item => { return item.id })} };
          if (item.componentsID.length > 0) {
            this.deStructure(
              this.deepCopy(item.componentsID),
              "children"
            );
          }
        }
        if(state == "root" && index == (items.length - 1)) {
          this.isSave = true;
        }
      });
      if(this.isSave) {
        this.initData();
        this.snap();
      }
    },
    async scrollToMenu(value) {
      if (value) {
        const timer = setInterval(() => {
          let $elem = document.getElementById("menu-item-" + value);
          if ($elem) {
            clearInterval(timer);
            setTimeout(() => {
              $elem.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500); // delay for dom render
          }
        }, 1);
      }
    },
  },
};
</script>

<style lang="scss">
#modal-manage-header-menu {
  .modal-dialog-scrollable .modal-content {
    overflow: unset !important;
  }
  /* Customize website's scrollbar like Mac OS
  Not supports in Firefox and IE */

  /* total width */
  ::-webkit-scrollbar {
    background-color: #fff;
    width: 15px;
  }

  /* background of the scrollbar except button or resizer */
  ::-webkit-scrollbar-track {
    background-color: #fff;
  }

  /* scrollbar itself */
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }

  /* set button(top and bottom of the scrollbar) */
  ::-webkit-scrollbar-button {
    display: none;
  }
  .modal-header {
    padding: 15px 30px 25px 30px;
    .icon-question {
      font-size: 18px;
      /* width: 20px; */
      /* height: 20px; */
      color: rgba(0, 0, 0, 0.5);
    }
    .icon-close-modal {
      font-size: 24px;
      /* width: 24px; */
      /* height: 24px; */
      color: rgba(0, 0, 0, 0.5);
    }
    .modal-title {
      display: flex;
      align-items: center;
      .flag-icon {
        height: 16px;
        margin-top: -2px;
      }
    }
    .btn-add-menu {
      white-space: nowrap;
    }
    .wrapper-search {
      margin-left: 16px;
      width: 100%;
      height: 32px;
      position: relative;
      .icon-search svg {
        position: absolute; 
        left: 10px; 
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #A5A5A5;
      }
      input {
        padding: 0 32px;
        height: 32px;
        font-family: 'Sarabun';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }
      .icon-clear-text {
        position: absolute;
        right: 10px; 
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        font-size: 14px;
        color: #A5A5A5;
      }
    }
  }
  .modal-body {
    padding: 15px 30px 15px 30px;
    &.scrollbar-is-show {
      padding: 15px 15px 15px 30px;
    }
  }
}
#modal-manage-header-menu___BV_modal_body_ {
  position: static;
}
.modal-body.static .nestable,
.modal-body.static .nestable-item {
  position: static;
}
.modal-body.static .nestable-item .handler::before,
.modal-body.static .nestable-item .handler::after {
  display: none;
}
</style>
